import store from '@/store';
import HTTP from "@/_helpers/http";
import { AUTHENTICATION__API } from "@/_helpers/urls";
import router from '@/router';
import toast from "@/services/Notification";

let sessionCheckInterval = null;

export function startSessionMonitor() {
    // Clear any existing interval
    if (sessionCheckInterval) {
        clearInterval(sessionCheckInterval);
    }

    // Set up interval to check session every 30 seconds
    sessionCheckInterval = setInterval(async () => {
        try {
            // Only check if we have a token
            if (!store.state.authentication.token) {
                return;
            }

            const response = await HTTP().get(`${AUTHENTICATION__API.CHECK_SESSION}/${store.state.authentication.userId}`);

            // If session is not valid, force logout
            if (!response.data.valid) {
                // Handle force logout
                if (response.data.reason === 'force_logout') {
                    // Set forced logout info in localStorage so the logout dialog can show it
                    localStorage.setItem('force_logout', JSON.stringify({
                        time: new Date(),
                        device: response.data.device || 'another device'
                    }));

                    // Clear the token
                    store.commit('authentication/REMOVE_TOKEN');

                    // If we're not already on the login page, redirect
                    if (router.currentRoute.path !== '/') {
                        toast.error("Your session has been terminated because you logged in on another device");
                        router.push('/');
                    } else {
                        toast.error("Your session has been terminated because you logged in on another device");
                    }
                } else if (response.data.reason === 'session_expired') {
                    // Handle session expiration
                    store.commit('authentication/REMOVE_TOKEN');
                    toast.error("Your session has expired. Please log in again.");
                    router.push('/');
                }
            }
        } catch (error) {
            console.error('Session check failed:', error);

            // If we get a 401, the token is invalid
            if (error.response && error.response.status === 401) {
                store.commit('authentication/REMOVE_TOKEN');
                if (router.currentRoute.path !== '/') {
                    toast.error("Your session is invalid. Please log in again.");
                    router.push('/');
                }
            }
        }
    }, 3000); // Check every 30 seconds instead of every second
}

export function stopSessionMonitor() {
    if (sessionCheckInterval) {
        clearInterval(sessionCheckInterval);
        sessionCheckInterval = null;
    }
}